import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate, Loading, Error } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from '../../../uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <Loading />
  }

  if (error) {
    return <Error />
  }

  return (
    <SimpleShowLayout>
      <CardCommon title={translate('ra.entity.currency')} actions={<CardCrudBottomButtons btnEdit={true} />}>
        <Grid container spacing={3}>
          <ShowListElement label={'ID'} value={record.id} />
          <ShowListElement label={translate('ra.field.long_name')} value={record.long_name} />
          <ShowListElement label={translate('ra.field.short_name')} value={record.short_name} />
          <ShowListElement label={translate('ra.field.symbol')} value={record.symbol} />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const CurrencyShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} className='CrudShowContainer' actions={null}>
      <ShowContent {...props} />
    </Show>
  )
}
